import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export type AkaTravelProductBackend = {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: any;
};

export function mapToCommerceAkaTravel(data: {
  [key: string]: any;
}): AkaTravelProductBackend {
  return {
    name: INSURANCE_NAME_VALUE.AKA_TRAVEL,
    coverageGroup: data.coverage,
  };
}
